import { useEffect, useState } from 'react';
/**
 * Хук, который определяет пересечение целевого элемента с Viewport или заданным контейнером.
 *
 * @param target Целевой элемент для отслеживания пересечений
 * @param [root] Контейнер, относительно которого будет определяться пересечение целевого элемента
 * @param [isEnabled] Ручное отключение обработчика
 * @param [threshold] Допустимый процент пересечения target и root
 * @returns boolean - isIntersected
 */
export const useIntersectionListener = ({ root, target, isEnabled = true, threshold = 1, }) => {
    const [isIntersected, setIsIntersected] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        if (!target.current || !isEnabled || !window.IntersectionObserver) {
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (!entry) {
                return;
            }
            setIsInitialized(true);
            setIsIntersected(entry.isIntersecting);
        }, { threshold, root: root?.current });
        observer.observe(target.current);
        return () => {
            observer.disconnect();
            setIsIntersected(false);
        };
    }, [setIsIntersected, target, root, isEnabled, threshold]);
    return { isIntersected, isInitialized };
};
